import { createService } from '@bonanza-social/toolkit/api';
import { UserSettingsSchema } from './UserSettingsService.schemas';

export default createService(
  {
    getUserSettings: {
      method: 'GET',
      url: '/settings',
      params: {
        coinsPlayInfo: true,
      },
      responseSchema: UserSettingsSchema,
    },
  },
  ({ userId }) => `/Players/${userId}`,
);
